import React from 'react';

import { Button } from '../../Controls/Button/index.tsx';
import Icons from '../../Elements/Icons/index.ts';
import { Wrapper, Title, Text } from './styled.ts';

export interface IUpdateBanner {
  title: string;
  text?: string;
  onReload: () => void;
  dataTestId?: string;
}

const UpdateBanner: React.FC<IUpdateBanner> = ({ title, text, onReload, dataTestId }) => (
  <Wrapper>
    <div>
      <Title>{title}</Title>
      {text && <Text>{text}</Text>}
    </div>
    <Button primary iconOnly onClick={onReload} data-testid={dataTestId}>
      <Icons.Reload size={20} />
    </Button>
  </Wrapper>
);

export default React.memo(UpdateBanner);
